(function () {
  function armer(bloc) {
    var brut = bloc.getAttribute('data-fin');
    if (!brut) return;

    var fin = new Date(brut).getTime();
    if (isNaN(fin)) return;

    if (bloc.classList.contains('cm-chrono--termine')) return;

    function verifier() {
      if (Date.now() < fin) return;
      bloc.classList.add('cm-chrono--termine');
      clearInterval(minuteur);
      document.removeEventListener('visibilitychange', auRetour);
    }

    function auRetour() {
      if (!document.hidden) verifier();
    }

    var minuteur = setInterval(verifier, 1000);
    document.addEventListener('visibilitychange', auRetour);
    verifier();
  }

  function armerAlerte() {
    var bascules = document.querySelectorAll('[data-cm-chrono-bascule]');
    for (var i = 0; i < bascules.length; i++) {
      (function (bouton) {
        if (bouton.dataset.cmArme) return;
        bouton.dataset.cmArme = '1';
        var panneau = document.getElementById(bouton.getAttribute('aria-controls'));
        if (!panneau) return;

        function poser(ouvert, anime) {
          if (!anime) panneau.style.transition = 'none';
          panneau.dataset.ouvert = ouvert ? 'true' : 'false';
          bouton.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
          if (!anime) requestAnimationFrame(function () { panneau.style.transition = ''; });
        }

        var revenu = window.location.search.indexOf('customer_posted=true') !== -1;
        poser(revenu, false);
        if (revenu) {
          var champ = panneau.querySelector('input[type="email"]');
          if (champ) champ.focus({ preventScroll: true });
        }

        bouton.addEventListener('click', function () {
          var ouvert = panneau.dataset.ouvert !== 'true';
          poser(ouvert, true);
          if (ouvert) {
            var e = panneau.querySelector('input[type="email"]');
            if (e) e.focus({ preventScroll: true });
          }
        });
      })(bascules[i]);
    }
  }

  function demarrer() {
    var blocs = document.querySelectorAll('[data-cm-chrono]');
    for (var i = 0; i < blocs.length; i++) armer(blocs[i]);
    armerAlerte();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  document.addEventListener('shopify:section:load', demarrer);
})();
